









































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import Headline from '@/components/layout/Headline.vue'
import Bilderreihe from '@/components/layout/Bilderreihe.vue'
@Component({
  components: { Headline, Bilderreihe }
})
export default class Hausmeisterdienst extends Vue {
  get getLanguage() {
    return vxm.core.language
  }

  setLanguage(lang: string) {
    vxm.core.setLanguage(lang)
  }
}
